export default __webpack_public_path__ + "app/images/69fa4f9f295983fcd5c9fef17e1b8ee1.svg";